import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/ratingTypeGroupService";
const store = {};
const mutations = {
    GET_RATINGTYPEGROUP_SIMPLELIST(state, posts) {
        state.ratingTypeGroupSimpleList = posts;
        state.ratingTypeGroupSimpleListIsLoading = false;
    },
    GET_RATINGTYPEGROUP_FULLSIMPLELIST(state, posts) {
        state.ratingTypeGroupFullSimpleList = posts;
        state.ratingTypeGroupFullSimpleListIsLoading = false;
    },
    GET_RATINGTYPEGROUP_DETAIL(state, posts) {
        state.ratingTypeGroupDetail = posts.data;
        state.ratingTypeGrouppDetailChanged = false;
        state.ratingTypeGroupDetailIsLoading = false;
    },
    GET_ACCESSLIST_FOR_RATINGTYPEGROUP(state, posts) {
        state.accessList = posts.data;
        state.accessListChanged = false;
        state.accessListIsLoading = false;
    },
    SAVE_DETAIL(state, posts) {
        if (posts.success == true) {
            state.ratingTypeGrouppDetailChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    SAVE_ACCESSLIST_FOR_RATINGTYPEGROUP(state, posts) {
        if (posts.success == true) {
            state.accessListChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
};
const state = {
    ratingTypeGroupSimpleList: [],
    ratingTypeGroupSimpleListIsLoading: false,
    ratingTypeGroupFullSimpleList: [],
    ratingTypeGroupFullSimpleListIsLoading: false,
    ratingTypeGroupDetailIsLoading: false,
    ratingTypeGrouppDetailChanged: false,
    ratingTypeGroupDetail: {},
    accessListChanged: false,
    accessListIsLoading: false,
    accessList: [],
};
const getters = {};
const actions = {
    getRatingTypeGroupSimpleList({ commit }) {
        state.ratingTypeGroupListIsLoading = true;
        return axios
            .get(baseUri + '/GetSimpleList')
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_RATINGTYPEGROUP_SIMPLELIST', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
    getRatingTypeGroupFullSimpleList({ commit }) {
        state.ratingTypeGroupListIsLoading = true;
        return axios
            .get(baseUri + '/GetFullSimpleList')
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_RATINGTYPEGROUP_FULLSIMPLELIST', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
    getRatingTypeGroupDetail({ commit }, data) {
        state.ratingTypeGroupDetailIsLoading = true;
        return axios
            .get(baseUri + '/GetDetailVx?RtgId=' + data.rtgId)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_RATINGTYPEGROUP_DETAIL', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
    getAccessListForRatingTypeGroup({ commit }, data) {
        state.accessListIsLoading = true;
        return axios
            .get(baseUri + '/GetAccessListForRtg?RtgId=' + data.rtgId)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_ACCESSLIST_FOR_RATINGTYPEGROUP', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
    saveRatingTypeGroupDetail({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.ratingTypeGroupDetail));
        return axios
            .post(baseUri + '/SaveDetail', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_DETAIL', res.data);
                } else {
                    alert("An error occured while updating your record: " + res.data.errorMessage);
                }
                return res;
            });
    },
    saveAccessListForRatingTypeGroup({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.accessList));
        return axios
            .post(baseUri + '/SaveAccessListForRatingTypeGroup', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_ACCESSLIST_FOR_RATINGTYPEGROUP', res.data);
                } else {
                    alert("An error occured while updating your record: " + res.data.errorMessage);
                }
                return res;
            });
    },
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}